import store from "@/store";
import { differenceInSeconds } from "date-fns";
import { onUnmounted, Ref } from "vue";

export const useAssessmentCountDown = ({
  endsAtEpochTimeInSecs,
}: {
  endsAtEpochTimeInSecs: Ref<number>;
}) => {
  let countDownInterval: ReturnType<typeof setInterval> | undefined;

  const formattedEndsInSeconds = (seconds: number) => {
    if (seconds > 86400) {
      return `${(seconds / 3600).toFixed(0)} Hours`;
    }

    // return new Date((seconds || 0) * 1000).toISOString().substr(11, 8);
    return new Date((seconds || 0) * 1000).toISOString().slice(11, 19);
  };

  // ======================================================================
  // Count Down
  const beginAssessmentTimer = () => {
    countDownInterval = setInterval(() => {
      const remainingTime = Math.max(
        differenceInSeconds(new Date(endsAtEpochTimeInSecs.value), new Date()),
        0
      );
      store.commit(
        "UPDATE_ASSESSMENT_TIME_LEFT",
        formattedEndsInSeconds(remainingTime)
      );
      if (remainingTime == 0) {
        return clearInterval(countDownInterval);
      }
    }, 1000);
  };

  onUnmounted(() => {
    clearInterval(countDownInterval);

    //Remove the counter when the Page is closed
    store.commit("UPDATE_ASSESSMENT_TIME_LEFT", "");
  });

  return { beginAssessmentTimer };
};
